module.exports = __webpack_public_path__ + "static/witch_4k-daee86676a6911f791a615cabacb295f.webp";